import { Context } from '../server-middleware/context'
import Unified, { FeaturedProductUpdate, FeaturedTopicFromUnified } from './unified'
import CommunityApi from './community'
import { FeaturedEvent } from '../preact-components/widget-featured-topics/index.sync'

type TopicsListQuery = Array<{id: number, type: string} | number>

export interface BackendData {
  featuredTopics: Array<FeaturedTopicFromUnified|FeaturedEvent>
}

const getServerData = async (context: Context, topicsList: TopicsListQuery): Promise<BackendData['featuredTopics']> => {
  const topicIds = []
  const eventIds = []
  const productUpdateIds = []
  const unified = new Unified(context)
  const community = new CommunityApi(context)

  for (const topic of topicsList) {
    if (typeof topic === 'number') {
      topicIds.push(topic)
      continue
    }

    if (topic.type === 'event') {
      eventIds.push(topic.id)
    } else if (topic.type === 'productUpdate') {
      productUpdateIds.push(topic.id)
    } else {
      topicIds.push(topic.id)
    }
  }

  const productUpdates: Record<string, FeaturedProductUpdate | undefined> = await unified.getProductUpdatesIndexedById(productUpdateIds)
  const topics: Record<string, FeaturedTopicFromUnified | undefined> = await unified.getTopicsIndexedByPublicId(topicIds)

  const events: Record<string, FeaturedEvent | undefined> = await eventIds.reduce(async (events, eventId) => {
    try {
      return Object.assign(await events, {
        eventId: await community.getEvent(eventId)
      })
    } catch (err) {
      context.logger(err)
      return await events
    }
  }, Promise.resolve({}))

  return topicsList.map(topic => {
    if (typeof topic === 'number') return topics[topic.toString()]
    if (topic.type === 'productUpdate') return productUpdates[topic.id.toString()]
    if (topic.type === 'event') return events[topic.id.toString()]
    return topics[topic.id.toString()]
  }).filter(isSet)
}

function isSet<T extends any> (item: T | undefined): item is T {
  return !!item
}

export default getServerData
